import { createFileRoute } from '@tanstack/react-router';
import { zodSearchValidator } from '@tanstack/router-zod-adapter';

import { VesselSearchSchema } from '../../types/vesselDetailsSearchSchema';
import { VesselDetailPage } from '../vessel/VesselDetailPage/VesselDetailPage';

export const Route = createFileRoute('/_app/vessel/$id')({
    validateSearch: zodSearchValidator(VesselSearchSchema),
    component: VesselDetailPage,
});
